const addSpaces = (timeString: string): string => {
  return timeString.replace(/(\d+)([a-z])/g, "$1$2 ")
}

export const formatTimeRemaining = (
  timeToFinish: number | null,
  t: (key: string) => string,
  spaceBetween = false
): string | null => {
  if (timeToFinish === null) return null

  let res = ""

  const seconds = Math.floor((timeToFinish / 1000) % 60)
  const minutes = Math.floor((timeToFinish / (1000 * 60)) % 60)
  const hours = Math.floor((timeToFinish / (1000 * 60 * 60)) % 24)
  const days = Math.floor(timeToFinish / (1000 * 60 * 60 * 24))

  if (days) {
    res = res + `${days}${t("days")}`
  }
  if (hours) {
    res = res + ` ${hours}${t("h")}`
  }
  if (hours > 0 || minutes) {
    res = res + ` ${minutes}${t("minutes")}`
  }
  res = res + `${seconds > 0 ? ` ${seconds}${t("s")}` : ""}`

  if (!days && !hours && !minutes && !seconds) return ""

  res = res.trim()

  return spaceBetween ? addSpaces(res) : res
}
